import { z } from 'zod'

import { ChannelType } from 'common/core/constants/ChannelType'
import { lightFlowSchema } from 'shared/api/common/schemas/lightFlow'

const systemKeywordsFlowRequestSchema = z.object({ channel: z.nativeEnum(ChannelType) })

const systemFlowsResponseSchema = z.object({
  subscribe_flow: lightFlowSchema.nullable(),
  unsubscribe_flow: lightFlowSchema.nullable(),
})

const subscribeFlowResponseSchema = z.object({ flow: lightFlowSchema })

export const systemKeywordsSchemas = {
  getSystemFlows: {
    request: systemKeywordsFlowRequestSchema,
    response: systemFlowsResponseSchema,
    query: z.undefined(),
    path: z.undefined(),
  },
  getSubscribeFlow: {
    request: systemKeywordsFlowRequestSchema,
    response: subscribeFlowResponseSchema,
    query: z.undefined(),
    path: z.undefined(),
  },
  getUnsubscribeFlow: {
    request: systemKeywordsFlowRequestSchema,
    response: subscribeFlowResponseSchema,
    query: z.undefined(),
    path: z.undefined(),
  },
}
